import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface CoachDetailsCardProps {
  coach: {
    name_surname: string;
    photo_url?: string;
    university?: string;
    major?: string;
    university_placement_year?: number;
    placement_types?: string[];
    placement_ranks?: string[];
    remaining_slots?: number;
  };
}

export const CoachDetailsCard = ({ coach }: CoachDetailsCardProps) => {
  const placementType = coach.placement_types?.[0];
  const placementRank = coach.placement_ranks?.[0];

  return (
    // Kartı hafif şeffaf koyu yaptık ki arka plan gradyanı hoş gözüksün
    <Card className="lg:col-span-1 bg-slate-900/40 border-white/10 backdrop-blur-sm text-white">
      <CardHeader>
        <CardTitle className="text-white text-2xl">Mentörünüz</CardTitle>
        <CardDescription className="text-slate-300">
          Seçtiğiniz mentör hakkında detaylı bilgi
          {coach.remaining_slots !== null && coach.remaining_slots <= 3 && (
            <div className="mt-2 text-rose-400 font-bold animate-pulse">
              {coach.remaining_slots === 1
                ? "⚠️ Son kontenjan!"
                : `⚠️ Son ${coach.remaining_slots} kontenjan`}
            </div>
          )}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="text-center mb-6">
          {coach.photo_url ? (
            <img
              src={`/coaches/${coach.photo_url}.jpg`}
              alt={`${coach.name_surname}`}
              className="w-32 h-32 mx-auto rounded-full object-cover mb-4 border-2 border-[#4F46E5] shadow-xl"
            />
          ) : (
            // Profil fotoğrafı yoksa çıkan yer tutucu (yeni indigo renginde)
            <div className="w-32 h-32 mx-auto rounded-full bg-[#4F46E5]/20 mb-4 flex items-center justify-center border-2 border-[#4F46E5]/30">
              <span className="text-4xl text-white font-bold">{coach.name_surname?.[0]}</span>
            </div>
          )}
          <h3 className="text-2xl font-bold text-white">{coach.name_surname}</h3>
          <p className="text-slate-300 font-medium">{coach.university}</p>
        </div>

        {/* Bilgi Satırları */}
        <div className="space-y-3 bg-white/5 p-4 rounded-xl border border-white/5">
          <div className="flex justify-between items-center border-b border-white/10 pb-2">
            <span className="text-slate-400 text-sm">Yerleştiği Bölüm:</span>
            <span className="font-semibold text-white">{coach.major}</span>
          </div>
          <div className="flex justify-between items-center border-b border-white/10 pb-2">
            <span className="text-slate-400 text-sm">Yerleşme Yılı:</span>
            <span className="font-semibold text-white">{coach.university_placement_year}</span>
          </div>
          <div className="flex justify-between items-center border-b border-white/10 pb-2">
            <span className="text-slate-400 text-sm">Puan Türü:</span>
            <span className="font-semibold text-white">{placementType}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-slate-400 text-sm">Sıralama:</span>
            <span className="font-bold text-[#4F46E5] bg-white px-2 py-0.5 rounded text-sm">{placementRank}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};